export interface Step {
  title: string;
  subtitle: string;
  template: any;
  completed?: boolean;
}
